/**
 * Loads EXCO SDK by tagId
 * @param tagId - tag id from your app.ex.co account
 * @param target - DOM element OR Promise with DOM element to append script
 * @returns - Promise that will be resolved after script append.
 */
export function loadSDK(
  tagId: string,
  target: HTMLElement | Promise<HTMLElement> = document?.body
): Promise<void> {
  return new Promise(async (resolve, reject) => {
    if (document == null) {
      reject(
        Error('Documnet is not defined, please - run it in browser context')
      );
    }

    if (tagId?.length === 0) {
      reject(Error(`tagId is not valid: ${tagId}`));
    }

    if (target == null) {
      reject(Error('target is not provided'));
    }

    const sdkScript = document.createElement('script');
    sdkScript.type = 'text/javascript';
    sdkScript.src = `https://smart-placements-sdk.ex.co/v1/${tagId}/sdk.js`;

    if (target instanceof Promise || target['then'] !== undefined) {
      // Promise flow
      const targetElement = await target;
      targetElement.appendChild(sdkScript);
    } else {
      // Common flow
      target.appendChild(sdkScript);
    }

    resolve();
  });
}
